import { render, staticRenderFns } from "./TcPlayer.vue?vue&type=template&id=7a40ca25&"
import script from "./TcPlayer.vue?vue&type=script&lang=js&"
export * from "./TcPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports